import React, { Component } from "react";
import { Message } from "semantic-ui-react";

class MessageNotArtBlock extends Component {
  state = { visible: true };

  handleDismiss = () => {
    this.setState({ visible: false });

    setTimeout(() => {
      this.setState({ visible: true });
    }, 10000);
  };

  render() {
    if (this.state.visible) {
      return (
        <Message
          compact
          color="yellow"
          onDismiss={this.handleDismiss}
          header="Lembrete!"
          content="Somente o RT pode assinar, tem dúvida? fale conosco."
        />
      );
    }

    return (
      <p>
        <br />
        <i>A mensagem aparecerá em breve.</i>
        <br />
        <br />
      </p>
    );
  }
}

export default MessageNotArtBlock;
